import React, { useContext, useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { ConfigContext } from "../Context/ConfigContext";
import axios from "axios";

const Header = () => {
  const { user_id, apiHeaderJson, apiURL, permissions } = useContext(ConfigContext)

  const [data, setData] = useState({})

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user_id");
    window.location.href = "/";
  };

  const getInfo = async () => {
    try {
      const headers = apiHeaderJson
      const response = await axios.get(`${apiURL}Users/GetUserInfo`, { headers, params: { user_id } })
      const { success, data } = response.data

      if (success) {
        setData(data[0])
      }
    } catch (error) {
      console.log("error", error)
    }
  }

  useEffect(() => {
    getInfo()
  }, [user_id]);

  // Function to check if user has view permission for a path
  const hasViewPermission = (path) => {
    if (!permissions || !Array.isArray(permissions)) return false;

    const permission = permissions.find(p =>
      p.privilege_description === path && p.privilege_view === 1
    );

    return !!permission;
  };

  // Function to filter menu items based on permissions
  const filterMenuItemsByPermission = (items) => {
    return items.filter(item => {
      if (item.isDropdown) {
        // For dropdown items, check if any child item has permission
        const filteredChildren = filterMenuItemsByPermission(item.items);
        return filteredChildren.length > 0;
      } else {
        // For regular items, check if user has view permission for the path
        return hasViewPermission(item.path);
      }
    }).map(item => {
      if (item.isDropdown && item.items) {
        // Return dropdown item with filtered children
        return {
          ...item,
          items: filterMenuItemsByPermission(item.items)
        };
      }
      return item;
    });
  };

  const menuItems = [
    {
      id: "dashboard",
      path: "/",
      icon: "ri-dashboard-2-fill",
      label: "Dashboard",
      isDropdown: false,
    },
    {
      id: "masters",
      icon: "ri-apps-2-line",
      label: "Masters",
      isDropdown: true,
      dropdownId: "sidebarMasters",
      items: [
        {
          id: "Users",
          path: "/Masters/ManageUser",
          label: "Manage User",
          isDropdown: false,
        },
        {
          id: "Categories",
          path: "/Masters/ManageCategory",
          label: "Manage Category",
          isDropdown: false,
        },
        {
          id: "HeroSliders",
          path: "/Masters/ManageHeroSlider",
          label: "Manage Hero Slider",
          isDropdown: false,
        },
        {
          id: "InquiryEmails",
          path: "/Masters/InquiryEmails",
          label: "Inquiry Emails",
          isDropdown: false,
        },
        {
          id: "prodcuts",
          label: "Prodcuts Management",
          isDropdown: true,
          dropdownId: "sidebarprodcuts",
          items: [
            {
              id: "ManageProducts",
              path: "/Masters/ManageProducts",
              label: "Manage Products",
              isDropdown: false,
            },
            {
              id: "ManageProductCategories",
              path: "/Masters/ManageProductCategories",
              label: "Manage Product Categories",
              isDropdown: false,
            },
            {
              id: "ProductList",
              path: "/Masters/ProductList",
              label: "Product List",
              isDropdown: false,
            },
          ]
        },
      ]
    }
  ];


  const renderMenuItems = (items) => {
    return items.map((item, index) => {
      if (item.isDropdown) {
        return (
          <li className="nav-item" key={`${item.id || item.label}-${index}`}>
            <a
              className="nav-link collapsed"
              href={`#${item.dropdownId}`}
              data-bs-toggle="collapse"
              role="button"
              aria-expanded="false"
              aria-controls={item.dropdownId}
            >
              {item.label}
            </a>
            <div className="collapse menu-dropdown" id={item.dropdownId}>
              <ul className="nav nav-sm flex-column">
                {renderMenuItems(item.items)}
              </ul>
            </div>
          </li>
        );
      } else {
        return (
          <li className="nav-item" key={`${item.id || item.label}-${index}`}>
            <NavLink to={item.path} className="nav-link">
              {item.label}
            </NavLink>
          </li>
        );
      }
    });
  };

  return (
    <>
      <header id="page-topbar">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              {/* LOGO */}
              <div className="navbar-brand-box horizontal-logo">
                <NavLink to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img alt="" height={72} />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="/assets/royal-logo.png"
                      alt=""
                      height={80}
                    />
                    <img alt="" height={100} />
                  </span>
                </NavLink>
                <NavLink to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img alt="" height={22} />
                  </span>
                  <span className="logo-lg">
                    <img
                      src="/assets/royal-logo.png"
                      alt=""
                      height={17}
                    />
                  </span>
                </NavLink>
              </div>
              <button
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span />
                  <span />
                  <span />
                </span>
              </button>
            </div>
            <div className="d-flex align-items-center">
              <div className="dropdown ms-sm-3 header-item topbar-user">
                <button
                  type="button"
                  className="btn"
                  id="page-header-user-dropdown"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <span className="d-flex align-items-center">
                    <img
                      className="rounded-circle header-profile-user"
                      src="/assets/logo/download.png"
                      alt="Header Avatar"
                    />
                    <span className="text-start ms-xl-2">
                      <span className="d-xl-infill-block ms-1 fw-medium user-name-text">
                        {data.login_id || "No user found!"}
                      </span>
                      <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                        {/* Founder */}
                      </span>
                    </span>
                  </span>
                </button>
                <div className="dropdown-menu dropdown-menu-end">
                  <h6 className="dropdown-header">Welcome {data.login_id}!</h6>
                  <div className="dropdown-divider" />
                  <NavLink
                    className="dropdown-item"
                    to="/"
                    onClick={handleLogout}
                  >
                    <i className="mdi mdi-logout text-muted fs-16 align-middle me-1" />
                    <span className="align-middle" data-key="t-logout">
                      Logout
                    </span>
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="app-menu navbar-menu">
        {/* LOGO */}
        <div className="navbar-brand-box">
          <NavLink to="/" className="logo logo-dark">
            <span className="logo-sm">
              <img src="/assets/royal-logo.png" alt height={22} />
            </span>
            <span className="logo-lg">
              <img src="/assets/royal-logo.png" alt height={17} />
            </span>
          </NavLink>
          <NavLink to="/" className="logo logo-light">
            <span className="logo-sm">
              <img src="/assets/royal-logo.png" alt height={22} />
            </span>
            <span className="logo-lg">
              <img src="/assets/royal-logo.png" alt height={50} />
            </span>
          </NavLink>
          <button
            type="button"
            className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
          >
            <i className="ri-record-circle-fill" />
          </button>
        </div>

        <div id="scrollbar">
          <div className="container-fluid">
            <div id="two-column-menu"></div>
            <ul className="navbar-nav" id="navbar-nav">
              <li className="menu-title">
                <span data-key="t-menu">Menu</span>
              </li>

              {menuItems.map((item) => (
                <li className="nav-item" key={item.id}>
                  {item.isDropdown ? (
                    <>
                      <a
                        className="nav-link menu-link"
                        href={`#${item.dropdownId}`}
                        data-bs-toggle="collapse"
                        role="button"
                        aria-expanded="false"
                        aria-controls={item.dropdownId}
                      >
                        <i className={item.icon} />
                        <span data-key="t-dashboards">{item.label}</span>
                      </a>
                      <div
                        className="collapse menu-dropdown"
                        id={item.dropdownId}
                      >
                        <ul className="nav nav-sm flex-column">
                          {renderMenuItems(item.items)}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <NavLink className="nav-link menu-link" to={item.path}>
                      <i className={item.icon} />
                      <span data-key="t-dashboards">{item.label}</span>
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
        {/* Sidebar */}
        <div className="sidebar-background"></div>
      </div>
      <div className="removeNotificationModal" id="removeNotificationModal" />
      <div
        className="vertical-overlay"
        onClick={() => {
          document.body.classList.remove("vertical-sidebar-enable");
          document.body.classList.remove("twocolumn-panel");
        }}
      />
    </>
  );
};

export default Header;